<template>
  <row class="bgs-list" :gutter="16" type="flex" align="top">
    <i-col span="24" v-for="bg in bgs" :key="bg.id">
      <bgs-item :bg="bg" @edit="$emit('edit', bg)" />
    </i-col>
  </row>
</template>

<script>
import BgsItem from './bgs-item'

export default {
  components: {
    BgsItem
  },
  props: ['bgs']
}
</script>

<style></style>
